// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class NoteRecord extends VerofreshRecord {
}

export default NoteRecord
